import { PageRoute, AppContext } from '@edx/frontend-platform/react';
import { Switch } from 'react-router-dom';
import React, { useContext, useLayoutEffect } from 'react';
import GoalUnsubscribe from './course-home/goal-unsubscribe';
import CoursewareRedirectLandingPage from './courseware/CoursewareRedirectLandingPage';
import { TabContainer } from './tab-page';
import { fetchDatesTab, fetchOutlineTab, fetchProgressTab } from './course-home/data';
import OutlineTab from './course-home/outline-tab/OutlineTab';
import DatesTab from './course-home/dates-tab';
import ProgressTab from './course-home/progress-tab/ProgressTab';
import { fetchCourse } from './courseware/data';
import { CourseExit } from './courseware/course/course-exit';
import CoursewareContainer from './courseware/CoursewareContainer';
import { doLoginRedirect } from './utils';

const App = () => {
  const { authenticatedUser, config } = useContext(AppContext);

  useLayoutEffect(() => {
    if (!authenticatedUser && config.LOGIN_URL) {
      doLoginRedirect();
    }
  }, [authenticatedUser, config.LOGIN_URL]);

  return (
    <Switch>
      <PageRoute exact path="/goal-unsubscribe/:token" component={GoalUnsubscribe} />
      <PageRoute path="/redirect" component={CoursewareRedirectLandingPage} />
      <PageRoute path="/course/:courseId/home">
        <TabContainer tab="outline" fetch={fetchOutlineTab} slice="courseHome">
          <OutlineTab />
        </TabContainer>
      </PageRoute>
      <PageRoute path="/course/:courseId/dates">
        <TabContainer tab="dates" fetch={fetchDatesTab} slice="courseHome">
          <DatesTab />
        </TabContainer>
      </PageRoute>
      <PageRoute
        path={[
          '/course/:courseId/progress/:targetUserId/',
          '/course/:courseId/progress',
        ]}
        render={({ match }) => (
          <TabContainer
            tab="progress"
            fetch={(courseId) => fetchProgressTab(courseId, match.params.targetUserId)}
            slice="courseHome"
          >
            <ProgressTab />
          </TabContainer>
        )}
      />
      <PageRoute path="/course/:courseId/course-end">
        <TabContainer tab="courseware" fetch={fetchCourse} slice="courseware">
          <CourseExit />
        </TabContainer>
      </PageRoute>
      <PageRoute
        path={[
          '/course/:courseId/:sequenceId/:unitId',
          '/course/:courseId/:sequenceId',
          '/course/:courseId',
        ]}
        component={CoursewareContainer}
      />
    </Switch>
  );
};

export default App;
